import React from 'react';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumb } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';

import routes from '../../constants/routes';

import { unselectJurisdictionAction } from '../../actions/proceedingActions';


const Navigator = props => {
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el history
    const history = useHistory();
    //Tomo los props
    const {items} = props;
    //Manejo la redirección
    const handleRedirectHome = e => {
        e.preventDefault();
        //Limpio
        dispatch( unselectJurisdictionAction() );
        //Redirecciono
        history.push(routes.HOME);
    }
    //Render
    return (
        <Breadcrumb>
            <Breadcrumb.Item onClick={ handleRedirectHome }>
                <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            {
                items ? (
                    items.map((item, index) => (
                        item.link ? (
                            <LinkContainer to={item.link} key={`item-${index}`}>
                                <Breadcrumb.Item active={item.active}>
                                    {
                                        item.icon ? (
                                            <FontAwesomeIcon icon={item.icon} />
                                        ) : (
                                            item.title
                                        )
                                    }
                                </Breadcrumb.Item>
                            </LinkContainer>
                        ) : (
                            <Breadcrumb.Item active={item.active} key={`item-${index}`} href="">
                                { item.title }
                            </Breadcrumb.Item>
                        )
                    ))
                ) : null
            }
        </Breadcrumb>
    );
};

export default Navigator;